import {
  Box,
  Flex,
  Form,
  SubmitButton,
  TextAreaInputField,
  theme,
} from '@/components';
import { useForm } from '@/hooks';
import { zodResolver } from '@hookform/resolvers/zod';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import type { z } from 'zod';

import { ApprovalReviewFormSchema } from '@/features/workflow/models/approval';

type FormValues = z.infer<typeof ApprovalReviewFormSchema>;

type Props = {
  initialValues?: Partial<FormValues>;
  onSubmit: (values: FormValues) => void;
};

export const ApprovalReviewForm: FC<Props> = ({ initialValues, onSubmit }) => {
  const { t } = useTranslation();
  const { token } = theme.useToken();
  const {
    handleSubmit,
    control,
    formState: { errors, isSubmitting, isDirty, isSubmitSuccessful },
  } = useForm<FormValues>({
    defaultValues: initialValues,
    resolver: zodResolver(ApprovalReviewFormSchema),
  });

  return (
    <Box backgroundColor={token.colorBgLayout} padding={8}>
      <Form
        leavePageAlertCondition={{
          isDirty,
          isSubmitting,
          isSubmitSuccessful,
        }}
        layout="vertical"
        onFinish={handleSubmit(onSubmit)}
      >
        <TextAreaInputField
          name="comment"
          label={t('message-review-comment')}
          control={control}
          errors={errors}
          rows={3}
          style={{ marginBottom: 8 }}
        />
        <Flex justify="end">
          {/* NOTE: Button disable by form isDirty is not implemented due to customer request */}
          <SubmitButton text={t('request-review')} loading={isSubmitting} />
        </Flex>
      </Form>
    </Box>
  );
};
